import React, { useState, useEffect } from "react";
import { Alert, Button } from "antd";
import { IconWifiOff, IconRefresh } from "@tabler/icons-react";

interface NetworkStatusProps {
  onRetry?: () => void;
}

const NetworkStatus: React.FC<NetworkStatusProps> = ({ onRetry }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineAlert, setShowOfflineAlert] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineAlert(false);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineAlert(true);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (!showOfflineAlert || isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <Alert
        message="No Internet Connection"
        description="You're currently offline. Some features may not work properly."
        type="warning"
        showIcon
        icon={<IconWifiOff size={16} />}
        action={
          <Button
            size="small"
            type="text"
            onClick={() => {
              if (onRetry) onRetry();
              window.location.reload();
            }}
            icon={<IconRefresh size={14} />}
          >
            Retry
          </Button>
        }
        banner
        closable
        onClose={() => setShowOfflineAlert(false)}
      />
    </div>
  );
};

export default NetworkStatus;
